var map = {
	"./OpenSkyLogoWithText.svg": 9182,
	"./Opensky.svg": 4591,
	"./ic-2D.svg": 3858,
	"./ic-account_circle.svg": 6521,
	"./ic-active-user.svg": 1683,
	"./ic-assignment-ind.svg": 6211,
	"./ic-call.svg": 4426,
	"./ic-card.svg": 6266,
	"./ic-check.svg": 3809,
	"./ic-circle-down.svg": 6005,
	"./ic-client-agents.svg": 168,
	"./ic-client-analytics.svg": 6401,
	"./ic-client-customers.svg": 162,
	"./ic-client-profile.svg": 239,
	"./ic-client-projects.svg": 9715,
	"./ic-client-system-admins.svg": 7411,
	"./ic-close.svg": 7918,
	"./ic-copy.svg": 5785,
	"./ic-customers.svg": 9346,
	"./ic-delete.svg": 3149,
	"./ic-down-arrow-red.svg": 3819,
	"./ic-down.svg": 7312,
	"./ic-download.svg": 2119,
	"./ic-edit-img.svg": 2170,
	"./ic-edit.svg": 3504,
	"./ic-empty-star.svg": 9513,
	"./ic-exclam.svg": 2008,
	"./ic-eye.svg": 2349,
	"./ic-file-download.svg": 9187,
	"./ic-handshake.svg": 8766,
	"./ic-home.svg": 155,
	"./ic-humburger.svg": 4545,
	"./ic-location.svg": 5190,
	"./ic-mail.svg": 2151,
	"./ic-multi-user.svg": 6571,
	"./ic-open-eye.svg": 746,
	"./ic-pdf.svg": 6538,
	"./ic-plus.svg": 9908,
	"./ic-profile.svg": 4851,
	"./ic-properties.svg": 5925,
	"./ic-reading-list.svg": 863,
	"./ic-search.svg": 1848,
	"./ic-share.svg": 8464,
	"./ic-tag.svg": 2530,
	"./ic-up-arrow-green.svg": 995,
	"./ic-user-menu.svg": 7699,
	"./ic-virtual-reality-bro.svg": 446,
	"./ic-vr.svg": 9684,
	"./ic-whatsApp.svg": 3708,
	"./logo.svg": 3190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8091;